import React from 'react';
import FormulaireSelectionProjet from '../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireVue.module.scss';
import SensorSelector from './SensorSelector';

interface CommonPlanningFormFieldsProps {
  projectId: string | number;
  setProjectId: (id: string | number) => void;
  viewName: string;
  viewId?: number;
  setViewName: (v: string) => void;
  description: string;
  setDescription: (v: string) => void;
  affichageProfil: boolean;
  sensorList?: any[];
  selectedSensors: any[];
  setSelectedSensors: (s: any[]) => void;
}

const CommonPlanningFormFields: React.FC<CommonPlanningFormFieldsProps> = ({
  projectId,
  setProjectId,
  viewName,
  setViewName,
  description,
  setDescription,
  affichageProfil,
  sensorList,
  selectedSensors,
  setSelectedSensors,
  viewId,
}) => {
  return (
    <>
      {/* Première ligne : Projet et Nom de la vue */}
      <div className={`${s.form_row} ${s.align_items_center}`}>
        <FormulaireSelectionProjet
          affichageProfil={affichageProfil}
          gererProjetId={setProjectId}
          preconfigurerProjetId={projectId}
        />

        <div className={`${s.col_6} ${styles.style}`}>
          <span className={styles.stil2}>{checkMot('view_name')} *</span>
          <input
            type="text"
            className={s.form_control}
            placeholder="view_name"
            name="view_name"
            value={viewName}
            disabled={affichageProfil}
            onChange={(e) => setViewName(e.target.value)}
            required
            aria-label={checkMot('view_name')}
          />
        </div>
      </div>

      {/* Deuxième ligne : Description en pleine largeur */}
      <div className={`${s.form_row} ${s.align_items_start}`}>
        <div className={`${s.col_12} ${styles.style}`}>
          <span className={styles.stil2}>{checkMot('description')}</span>
          <textarea
            className={`${s.form_control} ${styles.compact_textarea}`}
            placeholder="description"
            name="description"
            value={description}
            disabled={affichageProfil}
            onChange={(e) => setDescription(e.target.value)}
            aria-label={checkMot('description')}
            rows={1}
          />
        </div>
      </div>

      {/* Troisième ligne : Sélecteur de capteurs si applicable */}
      {sensorList && (
        <div className={`${s.form_row} ${s.align_items_start}`}>
          <div className={`${s.col_12} ${styles.style}`}>
            <SensorSelector
              selectedSensors={selectedSensors}
              sensorList={sensorList}
              setSelectedSensors={setSelectedSensors}
              idView={viewId}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CommonPlanningFormFields;
